import React from 'react'
import Loader from '@components/Loader'
import useGlobalLoader from '../../hooks/useGlobalLoader'

const LoaderView: React.FC = () => {
  const { loading } = useGlobalLoader()
  return (
    <Loader
      className='spinner global'
      type='ThreeDots'
      color='#333'
      visible={loading}
      height={100}
      width={100}
    />
  )
}

export default LoaderView
